import { render, staticRenderFns } from "./edit-admin.vue?vue&type=template&id=b570a160&scoped=true&"
import script from "./edit-admin.vue?vue&type=script&lang=js&"
export * from "./edit-admin.vue?vue&type=script&lang=js&"
import style0 from "./edit-admin.vue?vue&type=style&index=0&id=b570a160&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b570a160",
  null
  
)

export default component.exports